module.exports = __webpack_public_path__ + "img/pergola-over-door.2ca2d39a.webp";